(function (angular) {
  angular.module('acme.common.component.checkbox', []).component('acmeCheckbox', {
    templateUrl: 'common/components/checkbox/checkbox.component.tpl.html',
    controller: CheckboxController,
    transclude: {},
    require: {
      ngModelCtrl: 'ngModel',
    },
    bindings: {
      ngModel: '<',
      disabled: '<',
      indeterminate: '<',
    },
  });

  CheckboxController.$inject = ['$element'];

  var id = 0;

  function CheckboxController($element) {
    var ctrl = this;
    ctrl.id = 'acme-checkbox-' + ++id;

    ctrl.$onInit = function () {
      /**
       * ngAria will also add tabIndex which is not necessary in this component because we're using real checkbox inputs.
       * We would end up having to tab through both the acme-checkbox element and the internal checkbox.
       * @link https://docs.angularjs.org/guide/accessibility#ngmodel
       */
      $element.attr('tabindex', -1);
      $element.addClass('acme-checkbox');
    };

    ctrl.$onChanges = function (changes) {
      ctrl.stateChanged();
    };

    ctrl.ngModelChange = function () {
      ctrl.ngModelCtrl.$setViewValue(ctrl.ngModel);

      ctrl.stateChanged();
    };

    ctrl.stateChanged = function () {
      var active = ctrl.ngModel || ctrl.indeterminate;

      if (active) {
        $element.addClass('acme-checkbox--active');
      } else {
        $element.removeClass('acme-checkbox--active');
      }
    };
  }
})(window.angular);
